import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";

import BIMClassCard from "./BIMClassCard";
import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";

export default function BIMClassCardContainer(props) {
    const { Component = BIMClassCard, id, ...restProps } = props;

    const { i18n } = useTranslation();

    const bimClass = useSuspenseBIMClass(id).data?.bimClass;

    if (!bimClass) {
        return (<span>error loading BIM Class</span>);
    }

    return (
        <Component
            id={ bimClass.id }
            name={ t9n(bimClass.data.name, i18n.language) }
            type={ bimClass.data.type }
            { ...restProps }
        />
    );
}
